const initOcrActivity = {
    ocrActivities: [],
    currentPage: 1,
    totalPage: 1,
    limitPage: 10,
    lengthPage: 1,
    searchValue: "",
  };
  
  export const ocrActivityReducer = (
    state = initOcrActivity,
    action: any
  ) => {
    if (action.type === "SET_OCR_ACTIVITY") {
      return {
        ...state,
        ocrActivities: action.value,
      };
    }
    if (action.type === "SET_OCR_ACTIVITY_CURRENT_PAGE") {
      return {
        ...state,
        currentPage: action.currentPage,
      };
    }
    if (action.type === "SET_OCR_ACTIVITY_PAGE") {
      return {
        ...state,
        totalPage: action.totalPage,
        limitPage: action.limitPage,
        lengthPage: action.lengthPage,
      };
    }
    if (action.type === "SET_SEARCH_OCR_ACTIVITY") {
      return {
        ...state,
        searchValue: action.searchValue,
      };
    }
    return state;
  };
  